import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// CSS
import "./assets/css/libs.min.css";
import "./assets/css/main.css";
import "./assets/css/fonts.css";
import "./assets/css/fa/fa.min.css";
import "./assets/fonts/simple-line-icons/css/simple-line-icons.css";
// import "./assets/css/dataTable.min.css";
import "./assets/css/croppie.css";
// import "./styles/magazine.css";

// JS
import "./assets/js/libs.js";
import "./assets/js/main.js";
// import "./assets/js/dataTable.min.js";
import "./assets/js/croppie.js";

//UTIL

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
